<script setup lang="ts">
const { t } = useI18n();
useHead({
  title: t("p-tos-title"),
  meta: [
    {
      name: "description",
      content: t("p-tos-meta-description"),
    },
    {
      name: "keywords",
      content: t("p-tos-meta-keywords"),
    },
    {
      name: "robots",
      content: "noindex, nofollow",
    },
  ],
});
definePageMeta({ auth: false });
import { DUNS } from "@/shared/consts";

const { locale } = useI18n();
</script>

<template>
  <el-container style="margin: 50px" class="default-width">
    <el-header>
      <h1>{{ t("p-kyc-aml-policy-title") }}</h1>
      <a href="/docs/SolidSwap_AML_CTF_KYC_policy.docx">{{
        t("p-tos-download-link")
      }}</a>
    </el-header>
    <div class="mt-2 mb-3" v-if="locale !== 'en'">
      <el-alert :closable="false" type="warning">
        {{ t("p-tos-alert") }}
      </el-alert>
    </div>
    <el-main>
      <div>
        <div>
          <p>{{ t("p-kyc-warning") }}</p>
          <p>{{ t("p-kyc-illegal-funds-description") }}</p>
          <h2>
            <strong>{{ t("p-kyc-general-provisions-title") }}</strong>
          </h2>
          <p>{{ t("p-kyc-prevent-illegal-transactions") }}</p>
          <ul>
            <li>
              <p>{{ t("p-kyc-sender-recipient-same") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-contact-info-requirements") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-no-anonymous-connections") }}</p>
            </li>
          </ul>
          <p>{{ t("p-kyc-policy-description") }}</p>
          <ul>
            <li>
              <p>{{ t("p-kyc-no-business-with-criminals") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-no-criminal-transactions") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-no-facilitating-criminal-activity") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-right-to-restrict-services") }}</p>
            </li>
          </ul>
          <h2>
            <strong>{{ t("p-kyc-verification-procedures-title") }}</strong>
          </h2>
          <p>{{ t("p-kyc-kyc-policy-description") }}</p>
          <ul>
            <li>
              <p>{{ t("p-kyc-verification-steps") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-request-second-document") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-verification-authenticity") }}</p>
            </li>
          </ul>
          <p>{{ t("p-kyc-request-updated-documents") }}</p>
          <h2>
            <strong>{{ t("p-kyc-aml-compliance-title") }}</strong>
          </h2>
          <p>{{ t("p-kyc-aml-compliance-description") }}</p>
          <ul>
            <li>
              <p>{{ t("p-kyc-collect-user-info") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-create-update-policies") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-monitor-transactions") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-record-management") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-regular-risk-update") }}</p>
            </li>
          </ul>
          <p>{{ t("p-kyc-interaction-with-authorities") }}</p>
          <h2>
            <strong>{{ t("p-kyc-transaction-monitoring-title") }}</strong>
          </h2>
          <p>{{ t("p-kyc-monitoring-description") }}</p>
          <ul>
            <li>
              <p>{{ t("p-kyc-report-suspicious-transactions") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-request-additional-info") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-suspend-terminate-account") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-freeze-assets") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-return-funds") }}</p>
            </li>
            <li>
              <p>{{ t("p-kyc-risk-assessment") }}</p>
            </li>
          </ul>
          <p>{{ t("p-kyc-additional-monitoring") }}</p>
        </div>
      </div>

      <el-divider />
      <p>
        <strong>Data Universal Numbering System:</strong> {{ DUNS }}
        <a href="https://www.dnb.com/de-de/upik-en.html" target="_blank"
          >(Check D-U-N-S)</a
        >
      </p>
    </el-main>
  </el-container>
</template>
